// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1o7FI","fileBtn":"File_fileBtn__lAGL8","closeBtn":"File_closeBtn__u4mwN","fileSelected":"File_fileSelected__2KuSd","disabled":"File_disabled__B6gfv"};